<script>
    import { onMount } from "svelte";
    import { getTitle } from "../../../../../Utils/utilFunctions.svelte";

    import {
        CustomTooltip,
        TableComponentContainer,
    } from "../../../../Common/index.svelte";

    export let row = {};

    const truncateMaxWidth = 150;

    let isTruncated = false;

    onMount(() => {
        setTimeout(() => {
            checkIfTruncated();
        }, 1000);
    });

    const checkIfTruncated = () => {
        const hiddenContainer = document.createElement("div");
        hiddenContainer.style.position = "absolute";
        hiddenContainer.style.visibility = "hidden";
        hiddenContainer.style.whiteSpace = "nowrap";
        hiddenContainer.style.pointerEvents = "none";
        document.body.appendChild(hiddenContainer);

        hiddenContainer.style.fontSize = "14px";
        hiddenContainer.style.fontWeight = "400";

        hiddenContainer.innerHTML = `${_getDoctorName(row.doctor)}`;

        isTruncated = hiddenContainer.scrollWidth + 10 > truncateMaxWidth;

        document.body.removeChild(hiddenContainer);
    };

    // HELPER FUNCTIONS
    const _getDoctorName = ({ title, fullName }) => {
        return `${getTitle(title)} ${fullName}`;
    };
</script>

<TableComponentContainer customContainerClass="min-w-[{truncateMaxWidth}px]">
    <div class="flex flex-1 items-center justify-start">
        {#if isTruncated}
            <CustomTooltip
                contentClass="bg-[#fff] border-none"
                contentStyle="box-shadow: 4px 4px 13.7px 1px rgba(0, 0, 0, 0.25);"
                zIndex="10"
                hideTimeOutMs={50}
            >
                <p
                    class="text-left truncate cursor-pointer"
                    style="max-width: {truncateMaxWidth}px;"
                    slot="tooltipTrigger"
                >
                    {_getDoctorName(row.doctor)}
                </p>

                <p class="text-left cursor-text">
                    {_getDoctorName(row.doctor)}
                </p>
            </CustomTooltip>
        {:else}
            <p
                class="text-left truncate"
                style="max-width: {truncateMaxWidth}px;"
            >
                {_getDoctorName(row.doctor)}
            </p>
        {/if}
    </div>
</TableComponentContainer>
